import Vue from "vue";
import * as ENDPOINTS from "../services/endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class AppService {

    static async getSettings(){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.APPSETTINGS+'/all')
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    static async updateSettings(payload){
        try {
            const { data } = await Vue.http.put(ENDPOINTS.APPSETTINGS, payload);
            return  data
        } catch (error) {
            resolveRequestError(error)
        }
    }

    static async getNotifications({ page, limit}){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.APPNOTIFICATIONS+'/admin-list',{
                params:{
                    page,
                    limit
                }
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    static async createNotificaions(payload){
        try {
            const { data } = await Vue.http.post(ENDPOINTS.APPNOTIFICATIONS+'/admin-create', payload)
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    static async deleteNotification(payload){
        try {
            const { data } = await Vue.http.delete(ENDPOINTS.APPNOTIFICATIONS+`/${payload.id}`)
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }
    
}